var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex flex-column" },
    [
      _c(
        "div",
        {
          staticClass: "screen-mode-and-save justify-content-end",
          class: { "screen-mode-and-save-scroll": _vm.isScroll }
        },
        [
          _c("div", { staticClass: "wrap-screen-mode justify-content-end" }, [
            _c(
              "button",
              { staticClass: "save-button", on: { click: _vm.submitForm } },
              [_vm._v("\n        Save\n      ")]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "card-page" }, [
        _c("div", { staticClass: "icon-code-editor" }, [
          _c("img", {
            attrs: { src: require("@/assets/new-form-ui/code-editor.svg") },
            on: { click: _vm.openModalCodeEditor }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "tooltip-component" }, [
            _vm._v("\n        Code Editor\n      ")
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "icon-setup-view",
            class: {
              "error-input":
                _vm.$v.dataSetup.sorting.key.$error ||
                _vm.$v.dataSetup.sorting.order.$error
            },
            on: { click: _vm.openTableConfiguration }
          },
          [
            _c("img", {
              attrs: { src: require("@/assets/new-form-ui/setup.svg") }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "tooltip-component" }, [
              _vm._v("\n        Configuration\n      ")
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card-page-title card-page-title-white" },
          [
            _c("b-form", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.dataSetup.title,
                    expression: "dataSetup.title"
                  }
                ],
                staticClass: "input-title",
                class: { "error-input": _vm.$v.dataSetup.title.$error },
                attrs: { type: "text", placeholder: "Enter title here" },
                domProps: { value: _vm.dataSetup.title },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.dataSetup, "title", $event.target.value)
                  }
                }
              })
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "card-page-content pt-3" }, [
          _c(
            "section",
            [
              _vm.isLoading ? _c("j-skeleton-summary-block") : _vm._e(),
              _vm._v(" "),
              !_vm.isLoading
                ? _c(
                    "div",
                    { staticClass: "wrap-summary-block" },
                    [
                      _c(
                        "draggable",
                        {
                          staticStyle: { display: "flex" },
                          attrs: {
                            options: {
                              animation: 300
                            }
                          },
                          model: {
                            value: _vm.dataSetup.summary_block,
                            callback: function($$v) {
                              _vm.$set(_vm.dataSetup, "summary_block", $$v)
                            },
                            expression: "dataSetup.summary_block"
                          }
                        },
                        _vm._l(_vm.dataSetup.summary_block, function(
                          data,
                          index
                        ) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "container-summary-block sum-custom",
                              style: _vm.styleDivBlock(data)
                            },
                            [
                              _c("div", { staticClass: "item-name" }, [
                                _vm._v(_vm._s(data.name))
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "item-count" }, [
                                _vm._v("0")
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "edit-or-delete" }, [
                                _c("div", { staticClass: "button" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "edit",
                                      on: {
                                        click: function($event) {
                                          _vm.openConfigBlock(data, index)
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-pencil-square-o"
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "delete",
                                      on: {
                                        click: function($event) {
                                          _vm.deleteBlock(index)
                                        }
                                      }
                                    },
                                    [_c("i", { staticClass: "fa fa-trash" })]
                                  )
                                ])
                              ])
                            ]
                          )
                        })
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "add-block",
                          on: {
                            click: function($event) {
                              _vm.openConfigBlock(null, null)
                            }
                          }
                        },
                        [
                          _c("img", {
                            staticClass: "m__r--5",
                            attrs: {
                              src: require("@/assets/icon/add.png"),
                              height: "15",
                              width: "15"
                            }
                          }),
                          _vm._v("\n            Add Block\n          ")
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.dataSetup.auto_show_search_options_list
            ? _c(
                "section",
                [
                  _c("popup-filter", {
                    attrs: {
                      filters: _vm.dataSetup.search_options_list,
                      "is-auto-show": true
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "section",
            { staticClass: "mt-4" },
            [
              _c("div", { staticClass: "d-flex align-items-center mb-2" }, [
                _c(
                  "div",
                  { staticClass: "wrap-button-table" },
                  [
                    _c("b-button", { staticClass: "button-table" }, [
                      _c("i", { staticClass: "fa fa-plus fa-lg" }),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.dataSetup.config_native_button_table.add
                              .label || "Add"
                          ) +
                          "\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "edit-or-delete" }, [
                      _c("div", { staticClass: "button" }, [
                        _c(
                          "div",
                          {
                            staticClass: "edit",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                _vm.openModalNativeButtonTable(true, "add")
                              }
                            }
                          },
                          [_c("i", { staticClass: "fa fa-pencil-square-o" })]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "delete" }, [
                          !_vm.dataSetup.config_native_button_table.add
                            .is_hidden
                            ? _c("i", { staticClass: "fa fa-eye" })
                            : _c("img", {
                                staticStyle: { width: "12px" },
                                attrs: {
                                  src: require("@/assets/icon/eye-close.svg")
                                }
                              })
                        ])
                      ])
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "wrap-button-table" },
                  [
                    _c("b-button", { staticClass: "button-table" }, [
                      _c("i", { staticClass: "fa fa-cloud-upload fa-lg" }),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.dataSetup.config_native_button_table.import
                              .label || "Import"
                          ) +
                          "\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "edit-or-delete" }, [
                      _c("div", { staticClass: "button" }, [
                        _c(
                          "div",
                          {
                            staticClass: "edit",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                _vm.openModalNativeButtonTable(true, "import")
                              }
                            }
                          },
                          [_c("i", { staticClass: "fa fa-pencil-square-o" })]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "delete" }, [
                          !_vm.dataSetup.config_native_button_table.import
                            .is_hidden
                            ? _c("i", { staticClass: "fa fa-eye" })
                            : _c("img", {
                                staticStyle: { width: "12px" },
                                attrs: {
                                  src: require("@/assets/icon/eye-close.svg")
                                }
                              })
                        ])
                      ])
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "wrap-button-table" },
                  [
                    _c("b-button", { staticClass: "button-table" }, [
                      _c("i", { staticClass: "fa fa-download fa-lg" }),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.dataSetup.config_native_button_table.export
                              .label || "Export"
                          ) +
                          "\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "edit-or-delete" }, [
                      _c("div", { staticClass: "button" }, [
                        _c(
                          "div",
                          {
                            staticClass: "edit",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                _vm.openModalNativeButtonTable(true, "export")
                              }
                            }
                          },
                          [_c("i", { staticClass: "fa fa-pencil-square-o" })]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "delete" }, [
                          !_vm.dataSetup.config_native_button_table.export
                            .is_hidden
                            ? _c("i", { staticClass: "fa fa-eye" })
                            : _c("img", {
                                staticStyle: { width: "12px" },
                                attrs: {
                                  src: require("@/assets/icon/eye-close.svg")
                                }
                              })
                        ])
                      ])
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                !_vm.dataSetup.auto_show_search_options_list
                  ? _c(
                      "div",
                      { staticClass: "wrap-button-table" },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "btn grey btn-import-form m__r--5",
                            attrs: { id: "filterPopover" },
                            on: {
                              click: function($event) {
                                _vm.showPopover = true
                              }
                            }
                          },
                          [
                            _c("i", { staticClass: "fa fa-filter fa-lg" }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.dataSetup.config_native_button_table
                                    .filter.label || "Filter"
                                ) +
                                "\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "edit-or-delete" }, [
                          _c("div", { staticClass: "button" }, [
                            _c(
                              "div",
                              {
                                staticClass: "edit",
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    _vm.openModalNativeButtonTable(
                                      true,
                                      "filter"
                                    )
                                  }
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-pencil-square-o"
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "delete" }, [
                              !_vm.dataSetup.config_native_button_table.filter
                                .is_hidden
                                ? _c("i", { staticClass: "fa fa-eye" })
                                : _c("img", {
                                    staticStyle: { width: "12px" },
                                    attrs: {
                                      src: require("@/assets/icon/eye-close.svg")
                                    }
                                  })
                            ])
                          ])
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "wrap-button-table" },
                  [
                    _c("b-button", { staticClass: "button-table" }, [
                      _c("i", { staticClass: "fa fa-table fa-lg" }),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.dataSetup.config_native_button_table.group
                              .label || "Group"
                          ) +
                          "\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "edit-or-delete" }, [
                      _c("div", { staticClass: "button" }, [
                        _c(
                          "div",
                          {
                            staticClass: "edit",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                _vm.openModalNativeButtonTable(true, "group")
                              }
                            }
                          },
                          [_c("i", { staticClass: "fa fa-pencil-square-o" })]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "delete" }, [
                          !_vm.dataSetup.config_native_button_table.group
                            .is_hidden
                            ? _c("i", { staticClass: "fa fa-eye" })
                            : _c("img", {
                                staticStyle: { width: "12px" },
                                attrs: {
                                  src: require("@/assets/icon/eye-close.svg")
                                }
                              })
                        ])
                      ])
                    ])
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _vm.isLoading ? _c("j-skeleton-table") : _vm._e(),
              _vm._v(" "),
              !_vm.isLoading
                ? _c(
                    "div",
                    { staticClass: "columns" },
                    [
                      _c(
                        "draggable",
                        {
                          staticClass: "d-flex align-items-center",
                          attrs: {
                            options: {
                              animation: 300
                            }
                          },
                          model: {
                            value: _vm.dataSetup.column,
                            callback: function($$v) {
                              _vm.$set(_vm.dataSetup, "column", $$v)
                            },
                            expression: "dataSetup.column"
                          }
                        },
                        _vm._l(_vm.dataSetup.column, function(data, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "column" },
                            [
                              _c("div", { staticClass: "header-list" }, [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/icon/column-type/" +
                                      _vm.setIconType(data.type) +
                                      ".svg")
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "separator" }),
                                _vm._v(" "),
                                _c("div", { staticClass: "column-name" }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(data.name) +
                                      "\n                "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "edit-or-delete" }, [
                                  _c("div", { staticClass: "button" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "edit",
                                        on: {
                                          click: function($event) {
                                            _vm.openConfigColumn(data, index)
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-pencil-square-o"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "tooltip-component" },
                                          [_vm._v("Edit column")]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "delete",
                                        on: {
                                          click: function($event) {
                                            _vm.deleteColumn(index)
                                          }
                                        }
                                      },
                                      [
                                        _c("i", { staticClass: "fa fa-trash" }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "tooltip-component" },
                                          [_vm._v("Delete column")]
                                        )
                                      ]
                                    )
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _vm._l(4, function(index) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    staticClass: "column-preview",
                                    class: {
                                      "bg-gray": index === 2 || index === 4
                                    }
                                  },
                                  [
                                    _c("div", {
                                      staticClass: "content-preview"
                                    })
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        })
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "column" },
                        [
                          _c("div", { staticClass: "header-list" }, [
                            _c(
                              "div",
                              {
                                staticClass: "btn-add-block",
                                class: {
                                  "in-right": _vm.dataSetup.column.length === 0
                                },
                                on: {
                                  click: function($event) {
                                    _vm.openConfigColumn(null, null)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fa fa-plus" })]
                            )
                          ]),
                          _vm._v(" "),
                          _vm._l(4, function(index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "column-preview",
                                class: { "bg-gray": index === 2 || index === 4 }
                              },
                              [_c("div", { staticClass: "content-preview" })]
                            )
                          })
                        ],
                        2
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      !_vm.dataSetup.auto_show_search_options_list
        ? _c(
            "b-popover",
            {
              attrs: {
                show: _vm.showPopover,
                target: "filterPopover",
                container: "newExperienceManager",
                triggers: "click blur",
                placement: "bottom"
              },
              on: {
                "update:show": function($event) {
                  _vm.showPopover = $event
                }
              }
            },
            [
              _c("popup-filter", {
                attrs: { filters: _vm.dataSetup.search_options_list }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isOpenTableConfiguration
        ? _c("table-configuration", {
            attrs: {
              id: "tableConfiguration",
              "data-config": _vm.dataSetup,
              "list-function": _vm.listFunction,
              variables: _vm.variableOptions,
              "variable-options": _vm.variableOptionsClass,
              "variable-options-column": _vm.variableOptionsColumn,
              "source-type": _vm.sourceType
            },
            on: {
              "close-configuration": function($event) {
                _vm.toggleConfiguration(false)
              },
              submit: _vm.submitConfig
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isOpenConfigBlock
        ? _c("summary-block-configuration", {
            attrs: {
              id: _vm.idConfigBlock,
              "field-detail": _vm.selectedBlock,
              "variable-options": _vm.variableOptionsClass,
              "list-function": _vm.listFunction
            },
            on: {
              "delete-configuration": _vm.deleteBlock,
              "close-configuration": function($event) {
                _vm.toggleConfigurationBlock(false)
              },
              "submit-configuration": _vm.submitBlock
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isOpenConfigColumn
        ? _c("column-configuration", {
            attrs: {
              id: _vm.idConfigColumn,
              "primary-key": _vm.formDetail.form_data_id
                ? _vm.form_data_detail[0].primary_key
                : _vm.formDetail.data_source.external_url.primary_key,
              "field-detail": _vm.selectedColumn,
              "select-variable": _vm.variableOptionsColumn,
              "action-buttons": _vm.dataSetup.action_buttons,
              type: "table_view",
              "variable-options": _vm.variableOptions,
              "list-function": _vm.listFunction
            },
            on: {
              "delete-configuration": _vm.deleteColumn,
              "close-configuration": function($event) {
                _vm.toggleConfigurationColumn(false)
              },
              "submit-configuration": _vm.submitColumn
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showModalFieldLibrary
        ? _c("modal-field-library", {
            on: { "close-modal": _vm.closeModalFieldLibrary }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalExternalApi",
          staticClass: "modal-external-api",
          attrs: {
            "hide-header": true,
            "hide-footer": true,
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          }
        },
        [_vm.showModalExternalUrl ? _c("modal-external-api-field") : _vm._e()],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalScriptActionBtn",
          staticClass: "modal-native-action-button",
          attrs: {
            "hide-header": true,
            "hide-footer": true,
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          }
        },
        [
          _vm.showModalScriptActionBtn
            ? _c("modal-script-action-btn")
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.showModalNativeButton
        ? _c("modal-native-button-table", {
            attrs: {
              id: _vm.idModalNativeButtonTable,
              data:
                _vm.dataSetup.config_native_button_table[
                  _vm.selectedNativeButton
                ]
            },
            on: {
              "close-modal": _vm.closeModalNativeButtonTable,
              submit: _vm.submitNativeButtonTable
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalCodeEditor",
          staticClass: "modal-code-editor-wrap",
          attrs: {
            "hide-header": true,
            "hide-footer": true,
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          }
        },
        [
          _vm.showModalCodeEditor
            ? _c("modal-code-editor", {
                attrs: {
                  "view-data": _vm.viewJsonData,
                  "view-title": "Table View",
                  type: "table_view"
                },
                on: {
                  close: _vm.closeModalCodeEditor,
                  update: _vm.updateViewByCode
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-255344c2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-255344c2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/experience-manager-v2/menu/jTableView.vue
// module id = null
// module chunks = 